import {
  RemoveInstallationType_Input,
  useRemoveInstallationTypeMutation
} from 'generated/graphql';
import React from 'react';

export function useRemoveInstallationType() {
  const [
    fnMutate,
    tuple
  ] = useRemoveInstallationTypeMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: RemoveInstallationType_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
